import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Select,
  MenuItem,
  Button,
  Box,
  Typography,
  CircularProgress,
  Checkbox,
  Tooltip
} from "@mui/material";
import "../css/Breakwisetable.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useSalesContext } from '../../../Pages/SalesContext';

const BreakwiseTable: React.FC = React.memo(() => {
// const BreakwiseTable = () => {
  const { kpiData, salesUnit, loading } = useSalesContext();
  console.log("kpiData for breakage and expiry", kpiData , salesUnit);
  const card3Data = kpiData?.card3_data || [];
  
const handleDownload = (e) => {
  console.log("Download button clicked", e);

  const data = card3Data.map(item => [
    item.ItemName,
    item.ItemCode,
    item.Gross_Qty,
    (item.Gross_Sales / 100000).toFixed(2),
    item.Return_Qty,
    (item.Return_Sales / 100000).toFixed(2),
    item.Expiry_Qty,
    (item.Expiry_Sales / 100000).toFixed(2),
    item.Net_Qty,
    (item.Net_Sale / 100000).toFixed(2),
    (item.Non_SaleableReturn / 100000).toFixed(2),
    (item.SaleableReturn / 100000).toFixed(2)
  ]);

  const aoa = [
    ['Item Name', 'Item Code', 'Gross Qty', 'Gross Sales (Lacs)', 'Return Qty', 'Return Sales (Lacs)', 'Expiry Qty', 'Expiry Sales (Lacs)', 'Net Qty', 'Net Sale (Lacs)', 'Non Saleable Return (Lacs)', 'Saleable Return (Lacs)'],
    ...data
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(aoa);
  const csvString = XLSX.utils.sheet_to_csv(worksheet);
  const base64Csv = btoa(unescape(encodeURIComponent(csvString)));

  const message = {
    type: "DOWNLOAD_CSV",
    csv: base64Csv,
    fileName: "Breakage_data.csv",
    mimeType: "text/csv"
  };

  const isReactNativeWebView = !!window.ReactNativeWebView;
  const isInIframe = window.self !== window.top;

  if (isReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
  } else if (isInIframe) {
    window.parent.postMessage(JSON.stringify(message), "https://bsvdashqa.mankindpharma.in");
  } else {
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Breakage_data.csv";
    a.click();
    URL.revokeObjectURL(url);
    alert("File downloaded successfully!");
  }
};

 function formatNumberToRupees(number: number, salesUnit: any) {
  if (isNaN(number) || !isFinite(number)) return "";
  number = Math.abs(number);

  if (salesUnit === "Crores") {
    return (number / 10000000).toFixed(2);
  } else if (salesUnit === "Lacs") {
    return (number / 100000).toFixed(2);
  } else {
    return number.toFixed(2);
  }
}

  

 const data = card3Data.map(item => ({
  itemName: item.ItemName,
  itemCode: item.ItemCode,
  saleGrossQty: parseFloat(item.Gross_Qty.toFixed(2)),
  saleGrossAmt: item.Gross_Sales,
  returnQty: parseFloat(item.Return_Qty.toFixed(2)),
  returnAmount: item.Return_Sales,
  expiryQty: parseFloat(item.Expiry_Qty.toFixed(2)),
  expiryAmount: item.Expiry_Sales,
  netQty: parseFloat(item.Net_Qty.toFixed(2)),
  netSale: item.Net_Sale,
}));


  const grandTotals = data.reduce((totals, row) => {
    return {
      saleGrossQty: totals.saleGrossQty + row.saleGrossQty,
      saleGrossAmt: totals.saleGrossAmt + row.saleGrossAmt,
      returnQty: totals.returnQty + row.returnQty,
      returnAmount: totals.returnAmount + row.returnAmount,
      expiryQty: totals.expiryQty + row.expiryQty,
      expiryAmount: totals.expiryAmount + row.expiryAmount,
      netQty: totals.netQty + row.netQty,
      netSale: totals.netSale + row.netSale,
    };
  }, {
    saleGrossQty: 0,
    saleGrossAmt: 0,
    returnQty: 0,
    returnAmount: 0,
    expiryQty: 0,
    expiryAmount: 0,
    netQty: 0,
    netSale: 0,
  });
  
  return (
  <Box>
      <Box className="breakwise-second-container">
      <Box className="breakwise-header">
        <Box className="breakwise-title-container" style={{ display: 'flex', justifyContent: 'space-between', height: '90px' }}>
          <Typography className="breakwise-title">Item Wise Saleable and Non-Saleable Return ({salesUnit || "Lacs"})</Typography>
          <Button variant="outlined" className="breakwise-download-button" onClick={handleDownload}>
            Download MIS
          </Button>
        </Box>
      </Box>

      
<Box className="breakwise-table-container" style={{ display: 'flex' }}>
<TableContainer component={Paper} className="fixed-table-container">
 <Table stickyHeader size="small">
 <TableHead className="fixed-table-head" style={{ fontSize: '14px' }}>
 <TableRow>
 {['Item Name', 'Sale/Gross Qty', 'Sale/Gross Amt', 'Return Qty', 'Return Amount', 'Expiry Qty', 'Expiry Amount', 'Net Qty', 'Net Sale'].map((header, index) => (
 <TableCell key={header} style={index === 0 ? { position: 'sticky', left: 0, zIndex: 100 } : {}}>
{header}
 </TableCell>
 ))}
 </TableRow>
 </TableHead>
 <TableBody className="fixed-table-body">
  {data.map((row, index) => (
    <TableRow key={index} style={{ backgroundColor: index % 2 === 0 ? '#E6E6E6' : '#ffffff' }}>
      {['itemName', 'saleGrossQty', 'saleGrossAmt', 'returnQty', 'returnAmount', 'expiryQty', 'expiryAmount', 'netQty', 'netSale'].map((field, fieldIndex) => (
        <TableCell key={fieldIndex} className="breakage-custom-font" style={fieldIndex === 0 ? { position: 'sticky', left: 0, backgroundColor: index % 2 === 0 ? '#E6E6E6' : '#ffffff', zIndex: 1 } : {}}>
          <Tooltip  title={`${field.replace(/([A-Z])/g, ' $1').trim()}: ${
      typeof row[field] === 'number' && fieldIndex !== 0 && fieldIndex % 2 === 0
        ? formatNumberToRupees(row[field], salesUnit)
        : row[field]
    }, Item Name: ${row.itemName}, Item Code: ${row.itemCode}`}>
            <span>{fieldIndex === 0 || fieldIndex % 2 === 1 ? row[field] : formatNumberToRupees(row[field], salesUnit)}</span>
          </Tooltip>
        </TableCell>
      ))}
    </TableRow>
  ))}
</TableBody>

 </Table>
 </TableContainer>
</Box>

    </Box>
  </Box>
  );

});

export default BreakwiseTable;
